import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useContext } from 'react';
import { Card, Chip, DataGrid, Grid, GridRow, Icon, MenuItem, Spacer, Switch, Tooltip, Typography } from '@emburse/embark-core';
import { CheckIcon, CloseIcon } from '@emburse/embark-icons';
import { IconMenu } from '../../../components';
import { updateDirectoryStatus } from '../../../api/file';
import { createFolder } from '../../../api/ftpTodayAPI';
import { SFTPConfigContext } from '../SFTPConfigProvider';
import { $t, useTranslation } from '../../../hooks/useTranslation';
function ConfigurationTable({ createAllowed, loading, sftpPaths, updateCreateAllow, updateData, updateLoading }) {
    useTranslation();
    /** Context */
    const { searched } = useContext(SFTPConfigContext);
    /** Menu Options */
    const [selectedFolder, setSelectedFolder] = useState(null);
    return (_jsxs(Card, { children: [_jsxs(GridRow, { spacing: 1, justifyContent: "space-between", alignItems: "center", children: [_jsx(Grid, { item: true, children: _jsxs(GridRow, { spacing: 1, alignItems: "center", children: [_jsx(Grid, { item: true, children: _jsx(Typography, { variant: "subtitle1", children: $t('Internal Configuration') }) }), _jsx(Grid, { item: true, children: _jsx(Chip, { size: "small", color: "primary", label: "Certify Admin Only" }) })] }) }), _jsx(Grid, { item: true, children: _jsxs(GridRow, { spacing: 1, justifyContent: "space-between", alignItems: "center", children: [_jsx(Grid, { item: true, children: _jsx(Tooltip, { title: $t('Before enabling, you must search for previously created credentials.'), children: _jsx(Switch, { color: "primary", checked: createAllowed, value: createAllowed, onChange: () => updateCreateAllow(), disabled: !searched && !createAllowed }) }) }), _jsx(Grid, { item: true, children: _jsx(Typography, { variant: "body1", children: $t('Allow SFTP Account Creation') }) })] }) })] }), _jsx(Spacer, { size: 16 }), _jsx(DataGrid, { loading: loading, autoHeight: true, hideFooterPagination: true, hideFooter: true, rows: sftpPaths, columns: [
                    {
                        field: 'Name',
                        headerName: $t('Folder Path'),
                        flex: 1,
                        renderCell: (cell) => _jsx(Typography, { children: cell.value })
                    },
                    {
                        field: 'Internal',
                        headerName: $t('Public'),
                        width: 76,
                        renderCell: (cell) => (_jsx(Icon, { style: { color: !cell.value ? 'green' : 'red' }, iconUrl: !cell.value ? CheckIcon : CloseIcon }))
                    },
                    {
                        field: 'Valid',
                        headerName: $t('Valid'),
                        width: 76,
                        renderCell: (cell) => (_jsx(Icon, { style: { color: cell.value ? 'green' : 'red' }, iconUrl: cell.value ? CheckIcon : CloseIcon }))
                    },
                    {
                        field: 'Action',
                        headerName: ' ',
                        width: 56,
                        renderCell: (cell) => (_jsx("div", { style: {
                                width: '100%',
                                textAlign: 'right'
                            }, children: _jsx(IconMenu, { edge: "start", onOpen: () => {
                                    setSelectedFolder(cell.row);
                                }, children: selectedFolder && (_jsxs(_Fragment, { children: [_jsx(MenuItem, { onClick: () => {
                                                updateDirectoryStatus({
                                                    Path: selectedFolder.Path,
                                                    Internal: !selectedFolder.Internal
                                                }).then((resp) => {
                                                    if (resp.Status === 'success') {
                                                        updateData();
                                                    }
                                                });
                                            }, children: selectedFolder.Internal
                                                ? $t('Set Public')
                                                : $t('Set Internal') }), _jsx(MenuItem, { disabled: selectedFolder.Valid, onClick: () => {
                                                updateLoading();
                                                createFolder(selectedFolder.Name, 'Created via SFTP Config tool.').then((resp) => {
                                                    if (resp.Status === 'success') {
                                                        updateData();
                                                    }
                                                });
                                            }, children: $t('Create directory') })] })) }) }))
                    }
                ], localeText: {
                    noRowsLabel: $t('There are currently no SFTP directories to be managed.')
                } })] }));
}
export default ConfigurationTable;
